import React from "react";
import {autobind} from "core-decorators";
import {action, observable} from "mobx";
import {inject, observer} from "mobx-react";
import {Typography} from "antd";
import {AudioOutlined, PlusOutlined, QuestionCircleOutlined, ReadOutlined, TeamOutlined} from "@ant-design/icons";
import {RiBook3Line} from "react-icons/ri";
import {Link} from "react-router-dom";

import "./Home.scss";
import {paths} from "@/routes";
import logo from "./logo.svg";
import PageLayout from "@/components/PageLayout/PageLayout";
import Store from "@/stores";
import AddPieceUpgradeModal from "@/components/AddPieceUpgradeModal/AddPieceUpgradeModal";

export interface IHomeProps {
  store?: Store;
}

@inject("store")
@autobind
@observer
export default class Home extends React.Component<IHomeProps> {
  @observable addPieceModalVisible = false;

  @action
  closeAddPieceModal() {
    this.addPieceModalVisible = false;
  }

  @action
  openAddPieceModal() {
    this.addPieceModalVisible = true;
  }

  public render() {
    const {session} = this.props.store!;
    return (
      <PageLayout>
        <div className="Home">
          <img className="logo" src={logo} alt="Cantāmus" />
          <div className="text">
            <Typography.Paragraph>Welcome!</Typography.Paragraph>

            <Typography.Paragraph>
              Use the buttons below to access the musical pieces in your ensemble's repertoire, to explore your previous
              rehearsals or to learn more about how to use Cantāmus.
            </Typography.Paragraph>
          </div>

          <div className="links">
            {session.canAddPiece ? (
              <Link className="link" to={paths.pieceNew()}>
                <PlusOutlined />
                <div>Add Piece</div>
              </Link>
            ) : (
              <>
                <button className="link" onClick={this.openAddPieceModal}>
                  <PlusOutlined />
                  <div>Add Piece</div>
                </button>
                <AddPieceUpgradeModal close={this.closeAddPieceModal} visible={this.addPieceModalVisible} />
              </>
            )}
            <Link className="link" to={paths.pieces()}>
              <ReadOutlined />
              <div>My Repertoire</div>
            </Link>
            {session.isEnsembleConductor && (
              <Link className="link" to={paths.catalog()}>
                <RiBook3Line />
                <div>Catalog</div>
              </Link>
            )}
            <Link className="link" to={paths.rehearsals()}>
              <AudioOutlined />
              <div>Rehearsals</div>
            </Link>
            {session.isConductorOfProOrEnsemble && (
              <Link className="link" to={paths.ensembleRehearsals()}>
                <TeamOutlined />
                <div>Ensemble Rehearsals</div>
              </Link>
            )}
            <a className="link" href={paths.help()} target="_blank" rel="help noreferrer">
              <QuestionCircleOutlined />
              <div>Help</div>
            </a>
          </div>
        </div>
      </PageLayout>
    );
  }
}
